module.exports = __webpack_public_path__ + "img/logo-pocketorbit.c38087b5.png";